<template>
    <div class="table-layout">
        <el-table :data="goodsOrderItemList" border style="width: 100%">
            <el-table-column prop="title" label="商品名称" width="180"></el-table-column>
            <el-table-column  label="商品图片" width="60">
                <template slot-scope="rows">
                    <img style="height: 36px;width: 36px" :src="goodsOrderItemList.skuDefaultImageUrl"/>
                </template>
            </el-table-column>
            <el-table-column prop="brandName" label="品牌" width="180"></el-table-column>
            <el-table-column prop="quantity" label="数量"></el-table-column>
        </el-table>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import goodsOrderApi from '../../api/goodsOrder'

    export default {
        name: 'swb-goods-contract-item-list',
        desc: '合同商品清单',
        props :[ 'orderId' ],
        data: function () {
            return {
                goodsOrderItemList: [],
            }
        },
        created: function () {
            // --------------------查询--------------------------------
            this.toGetGoodsOrderList();
        },
        methods :{
            toGetGoodsOrderList: function () {
                let self = this;
                let postData = {
                    orderId : self.orderId
                };
                let msgBoxDlg = MsgBox.loading();
                goodsOrderApi.getGoodsOrderItemList(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type == "info") {
                        self.goodsOrderItemList = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/order/GoodsContractItemList.vue